import * as React from 'react';

import { colors } from '@/globalStyles';

export const IconMatrixAddSeparatorRight = props => {
  const fill = props?.fill || colors.nero;
  return (
    <svg width="31" height="30" viewBox="0 0 31 30" fill={fill} xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        strokeWidth="0"
        clipRule="evenodd"
        d="M9.24286 8.33333H19.7571C20.6408 8.33333 21.3571 9.16907 21.3571 10.2V19.8C21.3571 20.8309 20.6408 21.6667 19.7571 21.6667H9.24286C8.3592 21.6667 7.64286 20.8309 7.64286 19.8V10.2C7.64286 9.16907 8.3592 8.33333 9.24286 8.33333ZM19.7571 7C21.272 7 22.5 8.43269 22.5 10.2V19.8C22.5 21.5673 21.272 23 19.7571 23H9.24286C7.72802 23 6.5 21.5673 6.5 19.8V10.2C6.5 8.43269 7.72802 7 9.24286 7H19.7571Z"
      />
      <path
        fillRule="evenodd"
        strokeWidth="0"
        clipRule="evenodd"
        d="M14.9464 13.4176V14.4105H15.9393C16.2493 14.4105 16.5 14.6612 16.5 14.9712C16.5 15.2812 16.2493 15.5319 15.9393 15.5319H14.9464V16.5248C14.9464 16.8348 14.6957 17.0855 14.3857 17.0855C14.0757 17.0855 13.825 16.8348 13.825 16.5248V15.5319H12.8321C12.5222 15.5319 12.2714 15.2812 12.2714 14.9712C12.2714 14.6612 12.5222 14.4105 12.8321 14.4105H13.825V13.4176C13.825 13.1077 14.0757 12.8569 14.3857 12.8569C14.6957 12.8569 14.9464 13.1077 14.9464 13.4176Z"
      />
      <path d="M24.5 7V23" fill="none" stroke={fill} strokeLinecap="round" />
    </svg>
  );
};

export default IconMatrixAddSeparatorRight;
